import { render, staticRenderFns } from "./SpaymentreceiptsCreate.vue?vue&type=template&id=06a14fd2&scoped=true"
import script from "./SpaymentreceiptsCreate.vue?vue&type=script&lang=js"
export * from "./SpaymentreceiptsCreate.vue?vue&type=script&lang=js"
import style0 from "./SpaymentreceiptsCreate.vue?vue&type=style&index=0&id=06a14fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a14fd2",
  null
  
)

export default component.exports